import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Define the callback globally
    window.handleCredentialResponse = (response) => {
      // Send the token to the server
      fetch('/handle_login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ credential: response.credential })
      })
      .then(res => res.json())
      .then(data => {
        if (data.error) {
          console.error('Login error:', data.error);
        } else {
          console.log('Login successful');
          // Redirect to the previous page or root, replacing the login URL in history
          const redirectTo = data.redirectTo || '/';
          navigate(redirectTo, { replace: true });
        }
      })
      .catch(error => {
        console.error('Error during login:', error);
      });
    };

    const script = document.createElement('script');
    script.src = "https://accounts.google.com/gsi/client";
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
      // Clean up the global function
      delete window.handleCredentialResponse;
    };
  }, [navigate]);

  const containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    textAlign: 'center'
  };

  const titleStyle = {
    marginBottom: '20px'
  };

  return (
    <div style={containerStyle}>
      <h2 style={titleStyle}>To use Inbound Console, please authenticate.</h2>
      <div id="g_id_onload"
           data-client_id="155481446110-bcpe02i9ukopp95if9g6d0u761aogiff.apps.googleusercontent.com"
           data-context="signin"
           data-ux_mode="popup"
           data-callback="handleCredentialResponse"
           data-auto_prompt="false">
      </div>

      <div className="g_id_signin"
           data-type="standard"
           data-shape="rectangular"
           data-theme="outline"
           data-text="signin_with"
           data-size="large"
           data-logo_alignment="left">
      </div>
    </div>
  );
};

export default Login;